import { GallectionSortOrder } from '../../../../types/gallection';

export const DEFAULT_GALLECTION_SORT_ORDER = GallectionSortOrder.NEWEST;
